var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      { staticClass: "aawz-markdown-field__toolbar-tools" },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _vm._l(_vm.MARKDOWN_TOOLBAR_ITEMS, function(item, index) {
        return [
          item.type === "divider"
            ? _c("div", {
                key: "divider-" + index,
                staticClass: "aawz-markdown-field__divider"
              })
            : item.action === "createTable"
            ? _c(
                "v-menu",
                {
                  key: "table-" + index,
                  attrs: {
                    value: _vm.menuValue,
                    attach: _vm.menuAttach,
                    "offset-y": "",
                    "close-on-content-click": false,
                    disabled: !_vm.canEdit
                  },
                  on: {
                    input: function($event) {
                      return _vm.$emit("table-open", $event)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "btn-icon-square",
                                    attrs: {
                                      icon: "",
                                      "x-small": "",
                                      disabled: !_vm.canEdit,
                                      title: item.title
                                    },
                                    on: {
                                      mousedown: function($event) {
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "aawz-markdown-field__table-picker",
                      on: {
                        mouseleave: function($event) {
                          return _vm.$emit("table-clear")
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "aawz-markdown-field__table-grid" },
                        [
                          _vm._l(_vm.tablePicker.rows, function(row) {
                            return _vm._l(_vm.tablePicker.cols, function(col) {
                              return _c("div", {
                                key: "cell-" + row + "-" + col,
                                staticClass: "aawz-markdown-field__table-cell",
                                class: {
                                  "is-selected":
                                    row <= _vm.tablePicker.hoverRows &&
                                    col <= _vm.tablePicker.hoverCols
                                },
                                on: {
                                  mouseenter: function($event) {
                                    return _vm.$emit("table-hover", row, col)
                                  },
                                  mousedown: function($event) {
                                    $event.preventDefault()
                                    return _vm.$emit("table-apply", row, col)
                                  }
                                }
                              })
                            })
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "aawz-markdown-field__table-label" },
                        [_vm._v(" " + _vm._s(_vm.tablePickerLabel) + " ")]
                      )
                    ]
                  )
                ]
              )
            : _c(
                "v-btn",
                {
                  key: "btn-" + index,
                  staticClass: "btn-icon-square",
                  attrs: {
                    icon: "",
                    "x-small": "",
                    disabled: !_vm.canEdit,
                    title: item.title
                  },
                  on: {
                    mousedown: function($event) {
                      $event.preventDefault()
                    },
                    click: function($event) {
                      return _vm.$emit("toolbar-action", item)
                    }
                  }
                },
                [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                1
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }